import React from "react";
import "./index.scss";

function Footer() {

    return <>
    </>

    // return <div className={"app-footer"}>
    //     <p>
    //         CopyRight 2023 深圳市讯毅网络科技有限公司漳州分公司 All Rights Reserved.
    //     </p>
    //     <p>
    //         深圳市讯毅网络科技有限公司漳州分公司主营业务代理运营国内热门网页游戏，旗下网页游戏平台-“牛X游戏平台”
    //     </p>
    //     <p>
    //         <ul>
    //             <li>
    //                 联系QQ：3008402136
    //             </li>
    //             <li>
    //                 联系电话：181 2620 7507
    //             </li>
    //         </ul>
    //     </p>
    //     <p>
    //         <ul>
    //             <li>
    //                 软件名称&应用：神仙道网页版
    //             </li>
    //             <li>
    //                 软件著作权登记号：2021SR1109304
    //             </li>
    //             <li>
    //                 互联网游戏出版物ISBN号：978-7-89989-159-9
    //             </li>
    //             <li>
    //                 著作权人：厦门飞鱼科有限公司
    //             </li>
    //             <li>
    //                 出版单位: 厦门游家网络有限公司
    //             </li>
    //         </ul>
    //     </p>
    //     {/*<p>*/}
    //     {/*    CopyRight 2023 杭州心游网络科技有限公司 All Rights Reserved.*/}
    //     {/*</p>*/}
    //     {/*<p>*/}
    //     {/*    <ul>*/}
    //     {/*        <li>*/}
    //     {/*            软件名称&应用：心动神仙道网页游戏软件v2.0*/}
    //     {/*        </li>*/}
    //     {/*        <li>*/}
    //     {/*            登记号：2013SR064496*/}
    //     {/*        </li>*/}
    //     {/*        <li>*/}
    //     {/*            著作权人&开发者：上海心动企业发展有限公司*/}
    //     {/*        </li>*/}
    //     {/*    </ul>*/}
    //     {/*</p>*/}
    //     <p>
    //         <ul>
    //             <li>
    //                 <a target="_blank" rel="nofollow" href={"//p.niuxyx.com/statement/user-permission.html"}>用户权限</a>
    //             </li>
    //             <li>
    //             |
    //             </li>
    //             <li>
    //                 <a target="_blank" rel="nofollow" href={"//p.niuxyx.com/statement/user-privacy-agreement.html"}>隐私协议</a>
    //             </li>
    //             <li>
    //                 |
    //             </li>
    //             <li>
    //                 <a target="_blank" rel="nofollow" href={"//p.niuxyx.com/statement/profile.html"}>公司简介</a>
    //             </li>
    //         </ul>
    //
    //     </p>
    // </div>
}


export default Footer;